import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

const fallbackRender = ({ error }: { error: Error }) => {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre style={{ color: 'red' }}>{error.message}</pre>
    </div>
  )
}

const VDRErrorBoundary = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary
    fallbackRender={fallbackRender}
    onReset={(details) => {
      setTimeout(() => {
        window.location.reload()
      }, 5000)
    }}
  >
    {children}
  </ErrorBoundary>
)

export default VDRErrorBoundary
